import axios from "axios";
import authAxios, { getRefreshToken } from "./authAxios";
import { endpoints } from "../../api/endpoints";

export const authService = {
  login,
  logout,
  check,
};

function login(username, password) {
  return axios({
    url: endpoints.user.login,
    method: "POST",
    data: JSON.stringify({ username, password, generate_refresh_token: true, decoded_permissions: true, }),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function logout() {
  const refresh_token = getRefreshToken();
  if (refresh_token) {
    return authAxios({
      url: endpoints.user.logout,
      method: "POST",
      data: {
        refresh_token,
      },
    });
  }

  return Promise.resolve(true);
}

function check() {
  return authAxios({
    url: endpoints.user.check,
    method: "GET",
    params: {
      decoded_permissions: true,
    }
  });
}
